<template>
  <section class="py-10 bg-h-primary-50">
    <div class="container mx-auto">
      <GridLayout :list="setlist()" :banner="banner" @onScroll="scrollMeTo">
        <template #content>
          <Loader v-if="loader" :loader="loader" />

          <div v-show="!loader" class="flex flex-col gap-5 mt-10">
            <div :ref="enumLinks.general">
              <General :courseId="courseId" :studentId="studentId" />
            </div>
            <div v-if="isAdaptive" :ref="enumLinks.map" class="mt-3">
              <Map
                :courseId="courseId"
                :studentId="studentId"
                :type="'STATS_LEARNING_MAP'"
              />
            </div>
            <div :ref="enumLinks.quiz">
              <Quiz :courseId="courseId" :studentId="studentId" />
            </div>
            <div v-if="isAdaptive" :ref="enumLinks.attentionLogs">
              <AttentionLogs :courseId="courseId" :studentId="studentId" />
            </div>
          </div>
        </template>
      </GridLayout>
    </div>
  </section>
</template>

<script lang="ts">
import { User } from "@/models/user.model";
import { defineAsyncComponent, defineComponent } from "vue";

const GridLayout = defineAsyncComponent(() => import("../Grid/grid.vue"));
const General = defineAsyncComponent(() => import("./General/general.vue"));
const Map = defineAsyncComponent(() => import("./Map/map.vue"));
const Quiz = defineAsyncComponent(() => import("./Quiz/quiz.vue"));
const AttentionLogs = defineAsyncComponent(
  () => import("./AttentionLogs/attentionLogs.vue")
);

enum Links {
  general = "general",
  map = "map",
  quiz = "quiz",
  attentionLogs = "attentionLogs",
}

export default defineComponent({
  name: "studentStats",
  components: { GridLayout, General, Map, Quiz, AttentionLogs },
  computed: {
    enumLinks(): typeof Links {
      return Links;
    },
    courseId(): any {
      return this.$route.params.courseId;
    },
    studentId(): any {
      return this.$route.params.studentId;
    },
    isAdaptive(): boolean {
      return JSON.parse(localStorage.getItem("isAdaptiveStats") as string);
    },
  },
  data() {
    return {
      list: {
        title: this.$route.params?.studentName,
        links: [
          {
            name: this.$t("stats.student.sidebar.general"),
            linkId: Links.general,
          },
          {
            name: this.$t("stats.student.sidebar.map"),
            linkId: Links.map,
          },
          {
            name: this.$t("stats.student.sidebar.quiz"),
            linkId: Links.quiz,
          },
        ],
      } as { title: string; links: { name: string; linkId: string }[] },
      banner: {
        icon: require("@/assets/images/stats/std-icon.svg"),
        background: require("@/assets/images/stats/std.svg"),
        title: "Aluno",
      },
      user: {} as User,
      performance: {},
      loader: true as boolean,
    };
  },
  mounted() {
    setTimeout(() => (this.loader = false), 1500);
  },
  methods: {
    scrollMeTo(refName: any): void {
      var element: HTMLElement | any = this.$refs[refName];
      var top = element?.offsetTop;

      if (refName === Links.general) window.scrollTo(0, 0);
      else window.scrollTo(0, top);
    },
    setlist(): { title: string; links: { name: string; linkId: string }[] } {
      if (this.isAdaptive) {
        this.list.links.push({
          name: this.$t("stats.course.sidebar.attentionLogs"),
          linkId: Links.attentionLogs,
        });
        return this.list;
      } else return this.list;
    },
  },
});
</script>
